import React from "react";
import { useNavigate } from "react-router-dom";
import BrandDesignHero from "../components/brand-design-hero";
import ColorPalette from "../components/color-palette";
import ScrollToTopButton from "../components/scroll-to-top-btn";

import logo from "../assets/powerhouse-full-logo.png";
import studio from "../assets/powerhouse-studio.jpg";
import orangeBg from "../assets/orange-bg.jpg";
import poster1 from "../assets/powerhouse-poster1.png";
import poster2 from "../assets/powerhouse-poster2.png";
import poster3 from "../assets/powerhouse-poster3.jpg";
import poster4 from "../assets/powerhouse-poster4.png";
import powerhouseWebsite from "../assets/powerhouse.mp4";
import starstruckBanner from "../assets/startstruck-banner.jpg";
import starstruckPosters from "../assets/startstruck-posters.png";
import starstruckWebsite from "../assets/starstruck.mp4";

const Powerhouse: React.FC = () => {
  const navigate = useNavigate();

  const colors = [
    { bgClass: "bg-powerhousered", hexColor: "#D44030" },
    { bgClass: "bg-powerhousebrown", hexColor: "#D48030" },
    { bgClass: "bg-black", hexColor: "#000000" },
  ];

  return (
    <div className="mx-10 md:mx-20 my-10">
      <button className="font-frank text-white text-lg hover:underline" onClick={() => navigate("/")}>← Back to Home</button>

      <h1 className="font-euro text-white text-3xl mt-8 mb-3">Powerhouse Studios</h1>
      <div className="border-t-4 border-orange"></div>
      <p className="text-white font-frankbook text-lg mt-5 mb-10">As the Marketing Manager at Powerhouse, I managed the social media accounts, designed posters and fliers advertising gigs - one of which was featured in HMV - and carried out email marketing. Furthermore, I re-branded the partner company, Starstuck, including the brand design and company website. </p>

      <BrandDesignHero
        background={studio}
        logo={logo}
        name="Powerhouse"
      />

      <ColorPalette background={orangeBg} colors={colors} />

      <h3 className="font-euro text-white text-2xl mt-6 mb-3">Brand Kit</h3>

      <table className="text-white text-lg lg:text-xl w-full">
        <tr>
          <td className="font-euro border-2 border-powerhousered p-5">Typography</td>
          <td className="border-2 border-powerhousered p-5">
            <p className="font-euro">Minion Pro Bold</p>
            <p className="font-frankbook">Minion Pro</p>
          </td>
        </tr>
        <tr>
          <td className="font-euro border-2 border-powerhousered p-5">Colour Palette</td>
          <td className="border-2 border-powerhousered p-5">
            <p className="font-frankbook"><strong>Red - </strong>Power / Energy</p>
            <p className="font-frankbook"><strong>Brown - </strong>Secure / Traditional / Reliable</p>
            <p className="font-frankbook"><strong>Black - </strong>Formality / Strength</p>
          </td>
        </tr>
      </table>
      
      <h2 className="font-euro text-white text-center text-3xl mt-14 mb-3">Poster Design</h2>
      <div className="border-t-2 border-orange mb-10"></div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <img src={poster1} alt="" />
        <img src={poster2} alt="" />
        <img src={poster3} alt="" />
        <img src={poster4} alt="" />
      </div>

      <h2 className="font-euro text-white text-center text-2xl mt-14 mb-3">Web Design</h2>
      <div className="border-t-2 border-orange mb-5"></div>
      <video className="lg:px-24" controls autoPlay muted><source src={powerhouseWebsite}></source></video>

      <h2 className="font-euro text-white text-center text-3xl mt-16 mb-3">Starstruck Re-branding</h2>
      <div className="border-t-2 border-orange mb-5"></div>
      <img src={starstruckBanner} alt="Starstruck logo banner" />
      <p className="text-white font-frankbook text-lg lg:text-xl bg-purple p-5">I undertook re-branding Powerhouse’s sister company, Starstruck, to refresh the look and feel of advertising materials and the online presence, including the website. This brought more attention to the services, gaining new interest from clients.</p>

      <img className="mt-8 md:px-10 lg:px-24" src={starstruckPosters} alt="Starstruck posters" />

      <h2 className="font-euro text-white text-center text-2xl mt-14 mb-3">Web Design</h2>
      <div className="border-t-2 border-orange mb-5"></div>
      <video className="lg:px-24 mb-20" controls autoPlay muted><source src={starstruckWebsite}></source></video>

      <ScrollToTopButton />
    </div>
  );
};

export default Powerhouse;
